import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { FetchTemplatesArgs, FetchTemplatesResponse } from '../types/types';
import request from '../../../app/api/requests';

export const getTemplates = createAsyncThunk<
  FetchTemplatesResponse,
  FetchTemplatesArgs,
  { rejectValue: string }
>(
  'tasks/getTemplates',
  async ({ page, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await request.get('/Task/Templates/', {
        params: {
          PageSize: limit,
          PageIndex: page,
        },
      });
      return { data: response.data, page };
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const serverMessage = error.message;
        return rejectWithValue(serverMessage);
      }
      return rejectWithValue(error instanceof Error ? error.message : 'Неизвестная ошибка');
    }
  })